import { Action } from '@ngrx/store';
import { ProductionPriceList, ProductionPriceListForm } from './state-models/production-price-list';
import { ProductionPriceCondition } from './state-models/production-price-condition';

export enum ProductionPriceListActionType {
  LoadProductionPriceListsAction = '[ ProductionPriceLists ] Load production price lists',
  LoadProductionPriceListAction = '[ ProductionPriceList ] Load production price list',
  ChangeProductionPriceListSortExpressionAction = "[ ProductionPriceList ] Change production price list Sort Expression",
  ChangeProductionPriceListFilterExpressionAction = "[ ProductionPriceList ] Change production price list Filter Expression",
  ChangeProductionPriceListPageAction="[ ProductionPriceList ] change production price list list page",
  ChangeProductionPriceListTotalCountAction="[ ProductionPriceList ] change product production price list total count",
  ChangeConditionsShowOnlyValidConditionsAction = "[ Admin ] change show valid Conditions only"
}

export class LoadProductionPriceListsAction implements Action {
  readonly type = ProductionPriceListActionType.LoadProductionPriceListsAction;
  constructor(public payload: ProductionPriceList[]) { }
}

export class LoadProductionPriceListAction implements Action {
    readonly type = ProductionPriceListActionType.LoadProductionPriceListAction;
    constructor(public payload: ProductionPriceCondition[]) { }
}

export class ChangeProductionPriceListSortExpressionAction
    implements Action
{
    readonly type =
    ProductionPriceListActionType.ChangeProductionPriceListSortExpressionAction;
    constructor(public payload: string) {}
}

export class ChangeProductionPriceListFilterExpressionAction
    implements Action
{
    readonly type =
    ProductionPriceListActionType.ChangeProductionPriceListFilterExpressionAction;
    constructor(public payload: string) {}
}

export class ChangeProductionPriceListPageAction implements Action{
    readonly type=
    ProductionPriceListActionType.ChangeProductionPriceListPageAction;
        constructor(public payload: number) { }
}

export class ChangeProductionPriceListTotalCountAction implements Action{
    readonly type = ProductionPriceListActionType.ChangeProductionPriceListTotalCountAction;
    payload: { totalCount: number};
    constructor(totalCount: number) {
        this.payload = { totalCount};
    }
}

export class ChangeConditionsShowOnlyValidConditionsAction implements Action {
  readonly type = ProductionPriceListActionType.ChangeConditionsShowOnlyValidConditionsAction;
  constructor(public payload: boolean) { }
}



export type ProductionPriceListAction =
  | LoadProductionPriceListsAction
  | LoadProductionPriceListAction
  | ChangeProductionPriceListSortExpressionAction
  | ChangeProductionPriceListFilterExpressionAction
  | ChangeProductionPriceListPageAction
  | ChangeProductionPriceListTotalCountAction
  |ChangeConditionsShowOnlyValidConditionsAction;

